<template>
  <el-card class="integration-painel-card">
    <IntegrationPainelCustomer ref="painelCustomer" />
    <div class="integration-painel-grid">
      <div class="integration-painel-item" v-for="record of tableData" :key="record.type">
        <div
          class="integration-painel-line"
          role="button"
          tabindex="0"
          @click="open(record)"
          @keyup.enter="open(record)"
          @keyup.space.prevent="open(record)">
          <span class="integration-painel-type">{{ record.type }}</span>
          <span class="integration-painel-total">{{ record.total }}</span>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import { IntegrationService } from "@/services/customers/integration.services";
import IntegrationPainelCustomer from "./IntegrationPainelCustomer.vue";

export default {
  name: "IntegrationPainel",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.painel()
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    open(record) {
      const vm = this;
      vm.$refs.painelCustomer.open(record.id, record.type);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      tableData: [],
    };
  },
  components: { IntegrationPainelCustomer }
};
</script>
<style>
.integration-painel-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 14px;
}

.integration-painel-item {
  min-width: 0;
}

.integration-painel-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 40px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.integration-painel-line:hover {
  border-color: #cbcbcb;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.16);
  transform: translateY(-1px);
}

.integration-painel-line:focus {
  outline: none;
  border-color: #606266;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
}

.integration-painel-type {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integration-painel-total {
  font-weight: 600;
  font-size: 14px;
  color: #606266;
}

@media (max-width: 1400px) {
  .integration-painel-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1024px) {
  .integration-painel-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .integration-painel-grid {
    grid-template-columns: 1fr;
  }
}

.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>
